"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require("common-utilities/src/functional_utility");

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _holdings_security_card = require("./holdings_security_card");

var _holdings_security_card2 = _interopRequireDefault(_holdings_security_card);

var _reactIntl = require("react-intl");

var _breakdown_table_child_card = require("./breakdown_table_child_card");

var _breakdown_table_child_card2 = _interopRequireDefault(_breakdown_table_child_card);

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundPCF = function (_React$PureComponent) {
  _inherits(FundPCF, _React$PureComponent);

  function FundPCF(props) {
    _classCallCheck(this, FundPCF);

    var _this = _possibleConstructorReturn(this, (FundPCF.__proto__ || Object.getPrototypeOf(FundPCF)).call(this, props));

    _this.renderPCFHoldingCard = function (holdingType, holdingData) {
      var placementId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (!holdingType || !holdingData || (0, _functional_utility.isNilOrEmpty)(holdingData.data)) {
        return null;
      }
      return _react2.default.createElement(_holdings_security_card2.default, {
        header: _string_utility2.default.renderFormattedLabel("", "pdp-holdings-security-header-" + holdingType),
        id: 'pcf-security-' + holdingType,
        holdingType: holdingType,
        data: holdingData,
        breakpoint: _this.props.breakpoint,
        cardDataChanged: function cardDataChanged() {},
        gaiaRedirectUrl: _this.props.gaiaRedirectUrl,
        country: _this.props.country,
        cusip: _this.props.cusip,
        role: _this.props.role,
        placementId: placementId,
        disclosureText: _this.props.fund.disclosures[placementId],
        currencyCode: _this.props.fund.currencyCode,
        numberFormat: _this.props.fund.numberFormat,
        visibleDataPoints: _this.props.fund.visibleData.visibleDataPoints
      });
    };

    _this.renderPCFHoldingCard = _this.renderPCFHoldingCard.bind(_this);
    return _this;
  }

  _createClass(FundPCF, [{
    key: "renderM12",
    value: function renderM12() {

      if (!(0, _functional_utility.doesVisibleDataPointContains)("SHOW_M12_CARD", this.props)) {
        return null;
      }

      var dataM12Details = (0, _ramda.pathOr)({}, ["historicalData", "m12Details"], this.props);

      if ((0, _functional_utility.isNilOrEmpty)(dataM12Details.data)) {
        return null;
      }

      var config = {
        id: 'm12-breakdown-child',
        header: _string_utility2.default.renderFormattedLabel("Cash Purchase Return List Notice", "pdp-m12-tab-label"),
        componentId: "m12",
        asOfDateKey: "pdp-m12-as-of-label",
        shouldAlwaysShowMore: true,
        hideEffectiveDate: false,
        grouping: false,
        showDashOn2ndColumn: true
      };

      return _react2.default.createElement(_breakdown_table_child_card2.default, {
        country: this.props.country,
        role: this.props.role,
        cusip: this.props.cusip,
        language: this.props.language,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        numberFormat: this.props.fund.numberFormat,
        activeTab: this.props.active,
        tooltip: this.props.tooltip,
        breakpoint: this.props.breakpoint,
        activeCardHandler: this.activeCardScrollHandler,
        visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
        breakdown: dataM12Details,
        componentId: config.componentId,
        key: config.id,
        asOfDateKey: config.asOfDateKey,
        header: config.header,
        id: config.id,
        showDashOn2ndColumn: config.showDashOn2ndColumn,
        shouldAlwaysShowMore: config.shouldAlwaysShowMore,
        hideEffectiveDate: config.hideEffectiveDate,
        grouping: config.grouping
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
        this.renderM12(),
        this.renderPCFHoldingCard('equity', (0, _functional_utility.pathOrNull)(["holdings", "pcfEquityHoldings"], this.props.fund), 'pdpEquityHoldingsTwEtf'),
        this.renderPCFHoldingCard('future', (0, _functional_utility.pathOrNull)(["holdings", "pcfFutureHoldings"], this.props.fund), 'pdpFutureHoldingsTwEtf'),
        this.renderPCFHoldingCard('cash', (0, _functional_utility.pathOrNull)(["holdings", "pcfCashHoldings"], this.props.fund), 'pdpCashHoldingsTwEtf')
      );
    }
  }]);

  return FundPCF;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(FundPCF, { withRef: true });